package `fun`.adaptive.ui.value

import `fun`.adaptive.resource.graphics.GraphicsResourceSet

val iconCache: MutableMap<String, GraphicsResourceSet> = mutableMapOf(

)